<template>
  <div class="page-login">
    <img src="@/assets/images/logo-vertical.png" alt="Logo Mercurio RFF" class="logo my-4">
    <LoginForm class="card-body" />
  </div>
</template>

<script>
export default {
  name: 'page-login',
  components: {
    LoginForm: () => import('../../components/Account/LoginForm'),
  },
  mounted () {
    this.$emit('title', 'Login');
  },
};
</script>

<style lang="scss">
.page-login {
  .logo {
    display: block;
    margin: auto;
    max-width: 175px;
  }
}
</style>
